// extracted by mini-css-extract-plugin
module.exports = {"parent_container":"knowmore_parent_container__1D_q_","content":"knowmore_content___wT7_","heading":"knowmore_heading__64D_T"};